<app-census-lines-group-view
  [groupViewData]="groupViewData"
  [allExpanded]="allExpanded"
  (actionClick)="onActionClick($event)"
>
</app-census-lines-group-view>
